import { Trans } from 'react-i18next'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { ComponentSettingKey } from '@/shared/builder'

import { CompQuantityWrapperCore } from '../core/quantity/wrapper'

function CompQuantityWrapper() {
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  const action = useBuilderActionContextV2()

  // tableData
  const { dbClient, tablesMap } = useDbClientContext()
  const tableId = compContext.settings?.[ComponentSettingKey.QuantityDataSource]
  const dbTable = tableId ? tablesMap.get(tableId) : undefined

  if (!dbClient) {
    return (
      <div className='flex justify-center items-center py-8'>
        <Trans>COMP_TABLE_NOT_FOUND</Trans>
      </div>
    )
  }

  return (
    <CompQuantityWrapperCore
      infos={infosProps}
      action={action}
      tableData={{ tableId, dbTable: dbTable as any, dbClient }}
    />
  )
}

export default CompQuantityWrapper
